"use client"

import { memo } from "react";
import Header from "./Header";
import Footer from "./Footer";
import BreakingStripe from "@/components/BreakingStripe";
import SpecialCategoriesStrip from "@/components/SpecialCategoriesStrip";
import BackToTop from "@/components/BackToTop";
import FcmSubscriber from "@/components/FcmSubscriber";

const MainLayout = ({ children }) => {
	return (
		<div className="min-h-screen flex flex-col bg-(--surface-secondary) text-(--text-primary)">
			{/*
			  Sticky chrome: must NOT sit under an overflow-x-hidden ancestor
			  (that disables position:sticky in browsers).
			*/}
			<div className="site-sticky-chrome">
				<Header />
				<SpecialCategoriesStrip />
				<BreakingStripe />
			</div>
			<main className="flex-1 w-full min-w-0 site-container py-4 md:py-5 overflow-x-hidden">
				<div className="min-w-0 w-full">{children}</div>
			</main>
			<div className="overflow-x-hidden">
				<Footer />
			</div>
			<BackToTop />
			<FcmSubscriber />
		</div>
	);
}

export default memo(MainLayout);
